import { useContext } from 'react'
import { IntakeContext } from 'context/IntakeContext'
import DataTable from 'components/Tables/DataTable'
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import { Routes, Route } from 'react-router-dom'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import { AgencyTable } from './components/AgencyTable'
import styled from '@emotion/styled'
import { Box, Card, Grid, Typography } from '@mui/material'
import { selectData } from 'layouts/onboarding'

const StyledHeader = styled.h1`
  margin: 5px auto;
`

export const AgencyList = () => {
  const { intakeState } = useContext(IntakeContext)
  const agencyName =
    selectData.agency.find(({ value }) => value === intakeState?.agency)
      ?.label || ''
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <StyledHeader data-testid="agencyListHeader">
        {agencyName} Users
      </StyledHeader>
      {/* <Typography>
        **Admin Note: I am matching this to the agency of the current acessing
        user
      </Typography> */}
      <Box px={3} pb={3}>
        <Box mb={3}>
          <Grid container justifyContent="center">
            <Grid item xs={12}>
              <Card
                sx={{
                  textAlign: 'left',
                  boxShadow: 0,
                  borderRadius: 2,
                  border: '1px solid #D2D6DA',
                }}
              >
                <div data-testid="agencyTableContainer">
                  <AgencyTable />
                </div>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </DashboardLayout>
  )
}
